import {
  PeriodicalUsersStatistics,
  StatisticsTask,
} from 'models/statistics.model';
import { BotUsers } from 'models/user.model';
import apiClient from './base';

export const getUsers = async (): Promise<BotUsers[]> => {
  const { data } = await apiClient.get('/users');

  return data;
};

export const deleteUser = async (emails: string[]): Promise<void> => {
  const { data } = await apiClient.delete('/users', { data: { emails } });

  return data;
};

export const getActiveUsers = async (): Promise<PeriodicalUsersStatistics> => {
  const { data } = await apiClient.get('/users/active');

  return data;
};

export const getAmountOfRegistrations =
  async (): Promise<PeriodicalUsersStatistics> => {
    const { data } = await apiClient.get('/users/registrations');

    return data;
  };

export const getSkippedTasks = async (): Promise<StatisticsTask[]> => {
  const { data } = await apiClient.get('/tasks/skipped');

  return data;
};

export const getFailedTasks = async (): Promise<StatisticsTask[]> => {
  const { data } = await apiClient.get('/tasks/failed');

  return data;
};
